import * as dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(timezone);

const TIME_ZONE = dayjs.tz.guess();

export default TIME_ZONE;
